import { renderIf, html, css, LitEntity, SirenActionMixin } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-loading';
import './import-mapping-container';

class ImportMappingView extends SirenActionMixin(LitEntity) {
  static get properties() {
    return {
      availableHeaders: { type: Array },
      recordPreview: { type: Object },
      targetGroupGenerator: { type: Object },
      importPreviewRenderer: { type: Object },
      showMapping: { type: Boolean, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      .details-button {
        float: right;
      }
      .mapping-container {
        margin-top: 3em;
      }
      bn-surface {
        margin: 1em 0 0 0;
      }
    `];
  }

  render() {
    if (!this.entity) {
      return html`<bn-loading></bn-loading>`;
    }

    const { mapping, headers } = this.entity.properties;

    return html`
      <h2>Mapping</h2>
      <bn-surface>
        <button class="button button--contained details-button" @click="${() => this.showMapping = !this.showMapping}">
          ${this.showMapping ? 'Hide Details' : 'Show Details'}
        </button>
        ${renderIf(!this.showMapping, html`
          <import-preview
            .recordPreview="${this.recordPreview}"
            .mapping="${mapping}"
            .importPreviewRenderer="${this.importPreviewRenderer}"
          ></import-preview>
        `)}
        ${renderIf(this.showMapping, () => html`
          <div class="mapping-container">
            <import-mapping-container
              .availableHeaders="${this.availableHeaders}"
              .recordPreview="${this.recordPreview}"
              .selectedHeaders="${headers}"
              .targetGroups="${this.targetGroups.filter(({ targets }) => targets.length > 0)}"
              readonly
            ></import-mapping-container>
          </div>
        `)}
      </bn-surface>
    `;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    if (!this.entity) {
      return;
    }
    this.targetGroups = this.targetGroupGenerator(this.entity);
  }
}

window.customElements.define('import-mapping-view', ImportMappingView);
